import { merge, pickBy } from 'lodash';

/**
 * @param object - original object
 * @param mergedObject - object to merge with original object
 *
 * @returns new object which consists of recursively merged
 * keys of [object] and [mergedObject].
 *
 * For example:
 *
 * [object] { a: '1', b: { c: '2' } }
 * [mergedObject] { b: { d: '3' }, e: '4' }
 *
 * mergeObjects(object, mergedObject) {a: '1', b: {c: '2', d: '3'}, e: '4'}
 */
export const mergeObjects = (object, mergedObject) => merge({}, object, mergedObject);

/**
 * @param object - original object
 *
 * @returns new object which consists of only keys
 * that has a defined value
 *
 * For example:
 *
 * [object] { a: null, b: 1, c: undefined }
 *
 * omitUndefined(object) {b: 1}
 */
export const omitUndefined = (object) => pickBy(object, (value) => value === false || !!value);
